'use strict';

import * as Utils from '../utils/utils.js';
import { emendo_map } from '../map.js';

class emendo_map_mini extends emendo_map {

	constructor(map_id, map_place_id ) {

		// Build html structure
		const map_container = document.getElementById( map_id );
		const content = `
		<div id="map-mini-info"></div>
		<div id="map-mini-map"></div>
		`;
		map_container.innerHTML = content;

		// Call emendo_map
		super( 'map-mini-map' , 13 );

		// Test if there is a place
		if ( map_place_id == '') return;

		// Create base map then ...
		super.create().then( () => {

			// Get Place
			fetch( rest_object.map_api_url + 'places/' + map_place_id , {
					method: "GET",
					cache: "no-cache",
					headers: { "Content-Type": "application/json; charset=utf-8"  }
			} )
			.then( response => { return response.json() } ) // Get JSON
			.then( myPlace => this.addInfos( myPlace ) ) // Add infos
		    .then( myPlace => super.addMarker( myPlace ) ) // Create the marker on map
		    .catch(err => {
		    });

		});

	}

	/* Create Map
	-------------------------------------------------------------------------------------------------- */
	addInfos( place ) {
		const infos_container = document.getElementById( 'map-mini-info' );
		const content = `
		<p class="place-title"> ${ place['title'] } </p>
		<p class="place-address"> ${ place['address'] } </p>
		`;
		infos_container.innerHTML = content;

		return place;
	}
}

Utils.IsInDOM( 'map-mini' )
    .then(element => {
			new emendo_map_mini( element.id, element.dataset.place_id );
    })
    .catch( e => {} );
